import React from 'react';

const Casino = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "17",
    viewBox: "0 0 18 17",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_25937_41112)" }, /* @__PURE__ */ React.createElement("rect", { x: "1", y: "0.5", width: "16", height: "16", rx: "4.10256", fill: "white" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.30859 10.5513C6.21484 10.5513 6.95008 11.2857 6.9502 12.1919C6.9502 13.0982 6.21491 13.8335 5.30859 13.8335C4.40236 13.8334 3.66797 13.0981 3.66797 12.1919C3.66808 11.2857 4.40243 10.5514 5.30859 10.5513ZM12.6934 10.5513C13.5996 10.5513 14.3339 11.2857 14.334 12.1919C14.334 13.0982 13.5997 13.8335 12.6934 13.8335C11.7871 13.8335 11.0527 13.0982 11.0527 12.1919C11.0528 11.2857 11.7871 10.5513 12.6934 10.5513ZM9.41211 7.26904C10.3183 7.26904 11.0525 8.00356 11.0527 8.90967C11.0527 9.81598 10.3184 10.5513 9.41211 10.5513C8.50581 10.5513 7.77148 9.81597 7.77148 8.90967C7.77172 8.00356 8.50595 7.26906 9.41211 7.26904ZM5.30859 3.1665C6.21479 3.1665 6.95 3.90098 6.9502 4.80713C6.9502 5.71344 6.21491 6.44873 5.30859 6.44873C4.40236 6.44864 3.66797 5.71338 3.66797 4.80713C3.66816 3.90104 4.40248 3.1666 5.30859 3.1665ZM12.6934 3.1665C13.5996 3.1665 14.3338 3.90098 14.334 4.80713C14.334 5.71344 13.5997 6.44873 12.6934 6.44873C11.7871 6.44872 11.0527 5.71343 11.0527 4.80713C11.0529 3.90099 11.7872 3.16652 12.6934 3.1665Z",
      fill: "#033038"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_25937_41112" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "18",
      height: "16",
      fill: "white",
      transform: "translate(0 0.5)"
    }
  )))
);

export { Casino };
//# sourceMappingURL=Casino.js.map
